import { Document } from './Document'

class Book extends Document {
  sheets

  constructor (ref, sheets) {
    super(ref)

    this.sheets = sheets || []
    this.#sortSheets()
  }

  get pages () {
    return this.sheets.reduce((result, sheet) => {
      if (sheet.leftPage) result.push(sheet.leftPage)
      if (sheet.rightPage) result.push(sheet.rightPage)
      return result
    }, [])
  }

  get leftPages () {
    const result = []

    for (let i = 0; i < this.sheets.length; i++) {
      if (this.sheets[i].leftPage) {
        result.push(this.sheets[i].leftPage)
      }
    }

    return result
  }

  get rightPages () {
    const result = []

    for (let i = 0; i < this.sheets.length; i++) {
      if (this.sheets[i].rightPage) {
        result.push(this.sheets[i].rightPage)
      }
    }

    return result
  }

  get firstSheet () {
    return this.sheets.find((sheet) => sheet.order === 0)
  }

  get middleSheets () {
    return this.sheets.filter((sheet) => sheet.order > 0 && sheet.order < 9999)
  }

  get lastSheet () {
    return this.sheets.find((sheet) => sheet.order === 9999)
  }

  addSheet (sheet) {
    this.sheets.push(sheet)
    this.#sortSheets()
  }

  addSheets (sheets) {
    this.sheets.push(...sheets)
    this.#sortSheets()
  }

  moveSheet (oldIndex, newIndex) {
    const middleSheets = this.middleSheets
    const [moveableSheet] = middleSheets.splice(oldIndex, 1)
    middleSheets.splice(newIndex, 0, moveableSheet)
    return this.#recalculateSheetOrder(middleSheets)
  }

  #sortSheets () {
    this.sheets.sort((a, b) => a.order - b.order)
    this.#autonumberingPages()
  }

  #recalculateSheetOrder (middleSheets) {
    const result = []
    const recalculatedSheets = middleSheets.reduce((result, sheet, index) => {
      if (sheet.order !== index + 1) {
        sheet.order = index + 1
        result.push(sheet)
      }
      return result
    }, result)

    this.#sortSheets()
    return recalculatedSheets
  }

  #autonumberingPages () {
    // .filter((page) => this.sheets.some((sheet) => sheet.pages.includes(page._id))) <--
    this.pages.forEach((page, index) => {
      page.fields['page-number'] = index + 1
    })
  }
}

export { Book }
